import React, { useState, useCallback, useEffect, useRef } from "react";
import axios from "axios";
import { EyeOutlined } from "@ant-design/icons";
import {
  GoogleMap,
  LoadScript,
  Polygon,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { useLocation } from "react-router-dom";
import {
  Checkbox,
  Col,
  Row,
  Form,
  Select,
  AutoComplete,
  Input,
  Button,
  Spin,
} from "antd";
import { debounce } from "lodash";
import { authenticateToken } from "../../utils/auth";
import { useHistory } from "react-router";
import ShopMarker from "../../images/icon/ShopMarker.svg";
import DriverMarker from "../../images/icon/DriverMarker.svg";
import usePrevious from "../../hooks/PreviousState";
import TopHeading from "./TopHeading";
import {
  getParamValue,
  jcTypeArray,
  checkStatesAndPushToHistory,
} from "../../utils/index";
const { Option } = Select;
const containerStyle = {
  width: "100%",
  height: "500px",
};

const NieghborhoodViewAll = () => {
  const [path, setPath] = useState([
    { lat: 23.77879476160706, lng: 90.40235635145721 },
    { lat: 23.778873306015218, lng: 90.40999528273163 },
    { lat: 23.773807094538846, lng: 90.40295716627655 },
  ]);
  const [form] = Form.useForm();
  const history = useHistory();
  const [key, setKey] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const previousType = usePrevious(type);
  const previousKey = usePrevious(key);
  const [neighborhoodTitle, setNeighborhoodTitle] = useState([]);
  const [polygonOptions, setPolygonOptions] = useState({
    loading: false,
    list: null,
  });
  const [shopShow, setShopShow] = useState(true);
  const [hubShow, setHubShow] = useState(false);
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [allNeighborhood, setAllNeighborhood] = useState({
    loading: false,
    data: null,
  });

  const [allShops, setAllShops] = useState({
    loading: false,
    data: null,
  });
  // add new
  const [activeMarker, setActiveMarker] = useState(null);

  const shopActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const hubActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  // get polygon data
  const reseAllFieldData = () => {
    setKey("");
    setType("JC_MART");
    form.resetFields();
    history.replace(window.location.pathname);
    window.location.reload();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberNeighborhoodList")
    );

    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.type) setType(retrievedObject.type);
  }

  const getNeighborhood = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberNeighborhoodList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberNeighborhoodList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey, previousType],
        [key, type],
        ["key", "type"],
        history
      );
    }
    setAllNeighborhood({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/neighborhood/all` +
          (type ? `?type=${type}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setAllNeighborhood({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAllNeighborhood({ loading: false, data: [] });
        //console.error("Neighborhood: Error", err);
      });
  }, [limit, page, type, key]);

  const getAllShopList = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberShopList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberShopList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey, previousType],
        [key, type],
        ["key", "type"],
        history
      );
    }
    setAllShops({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/shop` +
          (type ? `?type=${type}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setAllShops({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAllShops({ loading: false, data: [] });
        // console.error("ShopList: Error", err);
      });
  }, [limit, page, type, key]);

  const getPolygonOptions = useCallback(async (key) => {
    setPolygonOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/neighborhood/all` +
          (type ? `?type=${type}` : ``) +
          (key ? `&key=${key}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setPolygonOptions({
          loading: false,
          list: res.data?.neighborhoods?.map((neighborhood) => ({
            label: neighborhood.name,
            value: neighborhood.name,
          })),
        });
      })
      .catch((err) => {
        setPolygonOptions({ loading: false, list: [] });
        console.error("Categories: Error", err);
      });
  }, []);

  useEffect(() => {
    getNeighborhood();
  }, [getNeighborhood]);
  useEffect(() => {
    getAllShopList();
  }, [getAllShopList]);
  const fetchRef = useRef(0);
  const polygonSearchDebounce = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getPolygonOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getPolygonOptions]);

  const position = {
    lat: 23.773414356724892,
    lng: 90.41340705259854,
  };

  //.log("get nrighborhood data:", path[0]);

  return (
    <>
      <TopHeading refetch={getNeighborhood} />
      <section className="search_area align-items-center justify-content-between w-100">
        <h4 className="mb-0">Neighborhood All</h4>
        <div className="flex">
          <Form form={form} className="search_form">
            <Form.Item initialValue={type}>
              <Select
                placeholder="Type"
                onChange={(val) => setType(val)}
                value={type}
              >
                {Object.values(jcTypeArray)?.map((type, i) => (
                  <Option value={type} key={i}>
                    {type?.replace("_", " ")}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="search" initialValue={key}>
              <AutoComplete
                onSearch={getPolygonOptions}
                onSelect={(val) => setKey(val.toString())}
                options={polygonOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  polygonOptions?.loading ? <Spin size="small" /> : null
                }
                style={{ width: 300 }}
              >
                <Input.Search
                  size="large"
                  placeholder="Search by Name"
                  onSearch={(val) => setKey(val)}
                  enterButton
                  loading={polygonOptions.loading}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>

            <div className="search_btn">
              <Button
                type="primary"
                danger
                size="large"
                onClick={reseAllFieldData}
              >
                Reset
              </Button>
            </div>
          </Form>
        </div>
      </section>

      <section className="bg-white p-3 rounded">
        <Checkbox
          type="checkbox"
          defaultChecked={true}
          onChange={(val) => setShopShow(val.target.checked)}
        >
          Shop
        </Checkbox>

        {/* <Checkbox onChange={(val) => setHubShow(val.target.checked)}>
          HUB
        </Checkbox> */}
        <div className="details-area mt-3">
          <LoadScript
            id="script-loader"
            googleMapsApiKey="AIzaSyBAV5ux84Aast-onJ1DOq7uspbN6doNxXQ"
            language="en"
            region="us"
          >
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={position}
              zoom={12}
            >
              {allNeighborhood?.data?.neighborhoods?.map((neighborhood) => (
                <Polygon
                  path={neighborhood?.polygon?.points?.map((point) => ({
                    lat: point?.y,
                    lng: point?.x,
                  }))}
                  options={{
                    strokeColor: "red",
                    strokeOpacity: 0.75,
                    strokeWeight: 2,
                    fillColor: "rgb(185 153 255 / 44%)",
                    fillOpacity: 0.6,
                    icons: [
                      {
                        // icon: lineSymbol,
                        offset: "0",
                        repeat: "20px",
                      },
                    ],
                  }}
                />
              ))}
              {shopShow &&
                allShops?.data?.shops?.map((shop) => (
                  <Marker
                    icon={ShopMarker}
                    title={shop?.name}
                    position={{
                      lat: shop?.location?.y,
                      lng: shop?.location?.x,
                    }}
                    onClick={(e) => {
                      window.open(`/shops/${shop?.id}/details`, `_blank`);
                    }}
                  ></Marker>
                ))}
              {hubShow &&
                allShops?.data?.shops?.map((shop) => (
                  <Marker
                    icon={DriverMarker}
                    title={shop?.name}
                    position={{
                      lat: shop?.hub?.location?.y,
                      lng: shop?.hub?.location?.x,
                    }}
                    onClick={() => hubActiveMarker(shop?.hub?.id)}
                  >
                    {activeMarker === shop?.hub?.id ? (
                      <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                        <div className="inner-body-wrapper">
                          <div className="inner-body">
                            <div className="single">
                              <div className="info-name">
                                <span>Hub ID</span>
                              </div>
                              <div className="info-desc">
                                <span>{shop?.hub?.id}</span>
                              </div>
                            </div>
                            <div className="single">
                              <div className="info-name">
                                <span>Hub Name</span>
                              </div>
                              <div className="info-desc">
                                <span>{shop?.hub?.name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </InfoWindow>
                    ) : null}
                  </Marker>
                ))}
            </GoogleMap>
          </LoadScript>
        </div>
      </section>
    </>
  );
};

export default React.memo(NieghborhoodViewAll);
